import { mutator } from 'satcheljs';
import {
    expandFileExtensionsFilterMenu,
    collapseFileExtensionsFilterMenu,
} from 'owa-files-filter-contextmenu';
import { getFilterMenuStore } from '../store/FilterMenuStore';

mutator(expandFileExtensionsFilterMenu, () => {
    const filterMenuStore = getFilterMenuStore();

    filterMenuStore.isExtensionFilterExpanded = true;
});

mutator(collapseFileExtensionsFilterMenu, () => {
    const filterMenuStore = getFilterMenuStore();

    filterMenuStore.isExtensionFilterExpanded = false;
});
